<template>
  <div class="contents">
    <div class="container-fluid">
      <div class="breadcrumb-main user-member justify-content-sm-between mb-3">
        <h4 class="text-capitalize fw-500 breadcrumb-title">
          <a @click="$router.go(-1)" style="cursor:pointer"><i class="fas fa-arrow-left"></i></a>
          &nbsp; Template Pesan Toko
        </h4>
        <div class="action-btn">
          <button class="btn btn-success text-white mr-2" @click="seedDefault" :disabled="isSeeding">
            <i class="fas fa-magic"></i> Generate Template Default
          </button>
          <button class="btn btn-primary text-white" @click="openAdd">
            <i class="fas fa-plus"></i> Tambah Template
          </button>
        </div>
      </div>

      <div class="alert alert-info mb-3">
        <b>Cara kerja:</b> Setiap event toko (order, pembayaran, pengiriman, donasi, dll) punya template WA dan/atau email sendiri.
        Klik <b>Generate Template Default</b> untuk buat template siap pakai. Template donasi otomatis ditambahkan saat fitur donasi diaktifkan.
      </div>

      <div class="card p-3 border bg-white radius-xl">
        <div v-if="isLoading" class="text-center py-4"><div class="spinner-border"></div></div>
        <div v-else-if="templates.length === 0" class="text-center text-muted p-4">
          Belum ada template. Klik <b>Generate Template Default</b> atau <b>Tambah Template</b>.
        </div>
        <div v-else class="table-responsive">
          <table class="table table-hover mb-0">
            <thead class="bg-light">
              <tr>
                <th>Event</th>
                <th>Preview WA</th>
                <th>Email Subject</th>
                <th>Channel</th>
                <th>Aktif</th>
                <th class="text-right">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="t in templates" :key="t.id">
                <td><code>{{ t.event_type }}</code></td>
                <td><small class="text-muted">{{ truncate(t.template_wa, 70) }}</small></td>
                <td><small>{{ truncate(t.template_email_subject, 40) || '—' }}</small></td>
                <td><span class="badge badge-info">{{ t.channel }}</span></td>
                <td>
                  <label class="mb-0" style="cursor:pointer" :title="t.is_active === 1 ? 'Nonaktifkan' : 'Aktifkan'">
                    <input type="checkbox" :checked="t.is_active === 1" :disabled="togglingId === t.id" @change="toggleActive(t)">
                  </label>
                </td>
                <td class="text-right">
                  <button class="btn btn-sm btn-primary" @click="openEdit(t)" title="Edit"><i class="fas fa-edit"></i></button>
                  <button class="btn btn-sm btn-danger ml-1" @click="del(t)" title="Hapus"><i class="fas fa-trash"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Modal Form -->
      <modal name="tpl_form" :height="'auto'" :adaptive="true" :scrollable="true" :width="'80%'">
        <div class="p-4">
          <h4>{{ editId ? 'Edit' : 'Tambah' }} Template</h4>
          <form @submit.prevent="save">
            <label>Event Type</label>
            <input v-model="form.event_type" class="form-control mb-2" placeholder="order_created" required>

            <label>Channel</label>
            <select v-model="form.channel" class="form-control mb-2">
              <option value="wa">WhatsApp Saja</option>
              <option value="email">Email Saja</option>
              <option value="both">WA + Email</option>
            </select>

            <div v-if="form.channel === 'wa' || form.channel === 'both'">
              <label>Template WA</label>
              <textarea v-model="form.template_wa" class="form-control mb-3" rows="6" placeholder="Halo {customer_name}..."></textarea>
            </div>

            <div v-if="form.channel === 'email' || form.channel === 'both'">
              <label>Email Subject</label>
              <input v-model="form.template_email_subject" class="form-control mb-2" placeholder="Konfirmasi Order">
              <label>Email Body (HTML)</label>
              <textarea v-model="form.template_email_body" class="form-control mb-3" rows="8"></textarea>
            </div>

            <div class="alert alert-secondary" style="font-size: 12px;">
              <b>Placeholder Order:</b> {customer_name}, {customer_phone}, {customer_email}, {order_id}, {invoice_number}, {total_amount}, {shipping_cost}, {products}, {payment_method}, {payment_url}, {shipping_address}, {shipping_courier}, {shipping_tracking}, {bank_account}, {shop_name}, {shop_url}, {digital_access}
              <br><b>Placeholder Donasi:</b> {donor_name}, {donor_phone}, {donor_email}, {donation_number}, {amount}, {message}, {campaign_title}, {payment_status}, {invoice_number}, {payment_method}, {payment_url}, {bank_account}, {shop_name}, {shop_url}
            </div>

            <label>
              <input type="checkbox" v-model="form.is_active_bool"> Aktif
            </label>
            <br><br>

            <div class="text-right">
              <button type="button" class="btn btn-secondary" @click="$modal.hide('tpl_form')">Batal</button>
              <button type="submit" class="btn btn-primary ml-2" :disabled="isSaving">
                {{ editId ? 'Simpan' : 'Tambah' }}
              </button>
            </div>
          </form>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shopId: null,
      templates: [],
      isLoading: false,
      isSaving: false,
      isSeeding: false,
      togglingId: null,
      editId: null,
      form: {
        event_type: '', channel: 'wa',
        template_wa: '', template_email_subject: '', template_email_body: '',
        is_active_bool: true,
      },
    };
  },
  mounted() {
    this.shopId = this.$route.params.id;
    this.load();
  },
  methods: {
    truncate(val, len) {
      if (!val) return '—';
      const s = String(val).replace(/\s+/g, ' ').trim();
      return s.length <= len ? s : s.slice(0, len) + '…';
    },
    async load() {
      this.isLoading = true;
      try {
        await this.$store.dispatch('shop_template/shop_template_list', this.shopId);
        const items = this.$store.state.shop_template.templates;
        this.templates = Array.isArray(items) ? items : [];
      } catch (e) {
        this.$toast.error('Gagal load templates');
        this.templates = [];
      } finally { this.isLoading = false; }
    },
    openAdd() {
      this.editId = null;
      this.form = { event_type: '', channel: 'wa', template_wa: '', template_email_subject: '', template_email_body: '', is_active_bool: true };
      this.$modal.show('tpl_form');
    },
    openEdit(t) {
      this.editId = t.id;
      this.form = {
        event_type: t.event_type, channel: t.channel || 'wa',
        template_wa: t.template_wa || '',
        template_email_subject: t.template_email_subject || '',
        template_email_body: t.template_email_body || '',
        is_active_bool: t.is_active === 1,
      };
      this.$modal.show('tpl_form');
    },
    async save() {
      this.isSaving = true;
      try {
        const payload = {
          event_type: this.form.event_type,
          channel: this.form.channel,
          template_wa: this.form.template_wa || null,
          template_email_subject: this.form.template_email_subject || null,
          template_email_body: this.form.template_email_body || null,
          is_active: this.form.is_active_bool ? 1 : 0,
        };
        if (this.editId) {
          await this.$store.dispatch('shop_template/shop_template_update', { shopId: this.shopId, id: this.editId, payload });
        } else {
          await this.$store.dispatch('shop_template/shop_template_create', { shopId: this.shopId, payload });
        }
        this.$toast.success('Tersimpan');
        this.$modal.hide('tpl_form');
        this.load();
      } catch (e) {
        this.$toast.error(e.response?.data?.message || 'Gagal save');
      } finally { this.isSaving = false; }
    },
    async toggleActive(t) {
      this.togglingId = t.id;
      const next = t.is_active === 1 ? 0 : 1;
      try {
        await this.$store.dispatch('shop_template/shop_template_update', {
          shopId: this.shopId,
          id: t.id,
          payload: {
            event_type: t.event_type,
            channel: t.channel || 'wa',
            is_active: next,
          },
        });
        t.is_active = next;
        this.$toast.success(next ? 'Template diaktifkan' : 'Template dinonaktifkan');
      } catch (e) {
        this.$toast.error(e.response?.data?.message || 'Gagal update status');
        this.load();
      } finally { this.togglingId = null; }
    },
    async del(t) {
      if (!confirm('Hapus template event "' + t.event_type + '"?')) return;
      try {
        await this.$store.dispatch('shop_template/shop_template_delete', { shopId: this.shopId, id: t.id });
        this.$toast.success('Dihapus');
        this.load();
      } catch (e) { this.$toast.error(e.response?.data?.message || 'Gagal'); }
    },
    async seedDefault() {
      this.isSeeding = true;
      try {
        const r = await this.$store.dispatch('shop_template/shop_template_seed', this.shopId);
        this.$toast.success(r.data.message);
        this.load();
      } catch (e) { this.$toast.error(e.response?.data?.message || 'Gagal'); }
      this.isSeeding = false;
    },
  },
};
</script>
